import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    FilterUpdateInput,
    UpdateSavedFilter as UpdateFilterMutation,
    UpdateSavedFilterVariables as UpdateFilterMutationVariables,
} from 'nutshell-graphql-types';

import UPDATE_FILTER from '../mutations/update-saved-filter.graphql';

export function useUpdateFilter(): {
    updateFilter: (arg1: FilterUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [updateFilter, {loading, error}] = useMutation<
        UpdateFilterMutation,
        UpdateFilterMutationVariables
    >(UPDATE_FILTER);

    return {
        updateFilter: (input: FilterUpdateInput) =>
            updateFilter({
                variables: {input},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
